import React, { Component } from 'react';
import {
  NavLink as Link,
  Switch,
  Route,
  withRouter,
} from 'react-router-dom';
import PageHelmet from '../../organisms/PageHelmet';
import ManageHomepage from '../../organisms/ManageHomepage';
import ManageAgenda from '../../organisms/ManageAgenda';
import ManagePeople from '../../organisms/ManagePeople';
import './Admin.css';

class Admin extends Component {

  render() {

    return (
      <div className="Admin">

        <PageHelmet pageTitle="Admin" />

        <div className="Admin-header">
          <nav>
            <Link activeClassName="active" to={`${this.props.match.url}/homepage`}>Manage <br className="only-mobile"/> Homepage</Link>
            |
            <Link activeClassName="active" to={`${this.props.match.url}/agenda`}>Manage <br className="only-mobile"/> Agenda</Link>
            |
            <Link activeClassName="active" to={`${this.props.match.url}/people`}>Manage <br className="only-mobile"/> People</Link>
          </nav>
        </div>

        <Switch>
          <Route path={`${this.props.match.path}/homepage`} component={ManageHomepage} />
          <Route path={`${this.props.match.path}/agenda`} component={ManageAgenda} />
          <Route path={`${this.props.match.path}/people`} component={ManagePeople} />
        </Switch>

      </div>
    );

  }

}

export default withRouter(Admin);



// WEBPACK FOOTER //
// ./src/component/pages/Admin/index.js